import React from 'react';
import './levels.css'
import Header from '../components/layout/header';
import pic9 from '../assets/pic9.png'
import pic11 from '../assets/pic11.png'
import Unlockedlevel from '../components/common/unlockedlevel';
import Settings from '../components/common/settings';
import pic13 from '../assets/pic13.png'
import { Link, useNavigate } from 'react-router-dom';
import pic111 from '../assets/pic111.png'
import './level2unlocked.css'
import { useLocation } from 'react-router-dom';
import pic113 from '../assets/pic113.png'
import { useState } from 'react';
import './level4unlocked.css'

const Level4unlocked = () => {
      const [settingsOpen, setSettingsOpen] = useState(false);

        const location = useLocation();
        const score = location.state?.score || 0;
        const lives = location.state?.lives || 0;
        const collected = location.state?.collected || 0;
        const starCount = location.state?.starCount || 0;
        const navigate = useNavigate();
        const level1Stars =
            Number(localStorage.getItem('level1Stars')) || 0;

        const level2Stars =
            Number(localStorage.getItem('level2Stars')) || 0;

        const level3Stars =
            Number(localStorage.getItem('level3Stars')) || 0;

    //     const handleBack = () => {
    //     navigate('/unlockedcharacter', {
    //         state: {
    //             score,
    //             lives,
    //             collected,
    //             starCount
    //         }
    //     });
    // };
    const handleBack = () => {
    navigate(-1);
};



    return ( 
        <section className='container-levels-page2'>
              {settingsOpen && <Settings onClose={() => setSettingsOpen(false)} />}


            <nav className='container-header-lvel4-unlock'>
                <Header
                    title='Levels'
                    title2='Levels'
                    onClick={() => setSettingsOpen(true)}
                    onClick2={(e) => {
                        e.preventDefault();  
                        handleBack();  }}
                    img={pic9}
                    icontext='Return icon'
                    img2={pic11}
                    icontext2='settings icon'
                    />
            </nav>

            <section className='levels-page-container4'>


                 <section className='levels-number-container-level3'>
                    <div className='container-level-number-nextt'>
                         <Link  to='/Level1start' className='linkkkunlocked'>
                        <div className='big-cont-next-level'>
                            <button className='button-next-levell'>
                                <div className='yellow-circle'>
                                    <h2 className='number-level'>1</h2>
                                    <h2 className='number-level2'>1</h2>
                                </div>
                            </button>
                                <div className='container2-next-level'>
                                </div>
                                
                                <figure className='container-stars'>

                                    <figure className='containerr-img-star2'>
                                            <img
                                                className='small-star'
                                                src={level1Stars >= 1 ? pic111 : pic113}
                                                alt='star'
                                            />
                                        </figure>

                                        <figure className='containerr-img-star'>
                                            <img
                                                src={level1Stars >= 2 ? pic111 : pic113}
                                                alt='star'
                                            />
                                        </figure>

                                        <figure className='containerr-img-star2'>
                                            <img
                                                className='small-star'
                                                src={level1Stars >= 3 ? pic111 : pic113}
                                                alt='star'
                                            />
                                        </figure>

                                </figure>
                            </div>
                        </Link>

                      
                    </div>


                    <div className='container-level3'>
                         <Link  to='/Level2start' className='linkkkunlocked'>
                        <div className='big-cont-next-level'>
                            <button className='button-next-levell'>
                                <div className='yellow-circle'>
                                    <h2 className='number-level'>2</h2>
                                    <h2 className='number-level2'>2</h2>
                                </div>
                            </button>
                                <div className='container2-next-level'>
                                </div>
                                
                                <figure className='container-stars'>

                                    <figure className='containerr-img-star2'>
                                            <img
                                                className='small-star'
                                                src={level2Stars >= 1 ? pic111 : pic113}
                                                alt='star'
                                            />
                                        </figure>

                                        <figure className='containerr-img-star'>
                                            <img
                                                src={level2Stars >= 2 ? pic111 : pic113}
                                                alt='star'
                                            />
                                        </figure>

                                        <figure className='containerr-img-star2'>
                                            <img
                                                className='small-star'
                                               src={level2Stars >= 3 ? pic111 : pic113}
                                                alt='star'
                                            />
                                        </figure>

                                </figure>
                            </div>
                        </Link>

                      
                    </div>


                    <div className='container-level3-4'>
                         <Link  to='/Level3start' className='linkkkunlocked'>
                        <div className='big-cont-next-level'>
                            <button className='button-next-levell'>
                                <div className='yellow-circle'>
                                    <h2 className='number-level'>3</h2>
                                    <h2 className='number-level2'>3</h2>
                                </div>
                            </button>
                                <div className='container2-next-level'>
                                </div>
                                
                                <figure className='container-stars'>

                                    <figure className='containerr-img-star2'>
                                            <img
                                                className='small-star'
                                                src={level3Stars >= 1 ? pic111 : pic113}
                                                alt='star'
                                            />
                                        </figure>

                                        <figure className='containerr-img-star'>
                                            <img
                                                src={level3Stars >= 2 ? pic111 : pic113}
                                                alt='star'
                                            />
                                        </figure>

                                        <figure className='containerr-img-star2'>
                                            <img
                                                className='small-star'
                                               src={level3Stars >= 3 ? pic111 : pic113}
                                                alt='star'
                                            />
                                        </figure>

                                </figure>
                            </div>
                        </Link>

                      
                    </div>


                    <div className='container-level4'>
                        <Link className='linkkkunlocked'>
                        <Unlockedlevel numb='4' 
                        link='/Level4start'
                        />
                        </Link>
                    </div>
                      
                 </section>
            </section>
        </section>
     );
}
 
export default Level4unlocked;